import React, {useContext, useEffect, useState, useMemo} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {StoreContext} from "../../../store/StoreContext";
import {handleCleanTitle, prepareText} from "../../../helpers";
import {Accordion, ListGroup} from "react-bootstrap";
import {localSession} from "../../../helpers/local-storage";
import {LOCAL_SESSION} from "../../../constants/local-entity";
import "./inspections.scss";

const Inspections = () => {
  const {rol} = useParams();
  const navigate = useNavigate();
  const {setAppTitle, formsAD, formsP, formsAM} = useContext(StoreContext);

  const sessionData = useMemo(() => localSession.getItem(LOCAL_SESSION), []);
  const assignedCenters = sessionData?.assignedCenters || [];

  const hasCentro = (name) => {
    if (Number(sessionData?.profile) === 1) return true;
    if (assignedCenters.length === 0) return true;
    return assignedCenters.some(c => c.centro === name);
  };

  const STORAGE_KEY = `sso_inspections_activeKey_${rol}`;

  const [searchValue, setSearchValue] = useState("");
  const [formsADByRol, setFormsADByRol] = useState([]);
  const [formsAMByRol, setFormsAMByRol] = useState([]);
  const [formsPByRol, setFormsPByRol] = useState([]);
  const [formsADByRolFiltered, setFormsADByRolFiltered] = useState([]);
  const [formsAMByRolFiltered, setFormsAMByRolFiltered] = useState([]);
  const [formsPByRolFiltered, setFormsPByRolFiltered] = useState([]);
  const [activeKey, setActiveKey] = useState(() => {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : ["0"];
    } catch { return ["0"]; }
  });
  const [accordionProps, setAccordionProps] = useState({
    flush: true,
    alwaysOpen: false,
  });

  useEffect(() => {
    setAppTitle("Inspecciones");
  }, []);
  
  //SE APLICO UN FILTRO PARA SACAR FORMULARIOS POR TEMPLATEID, ESTOS SON DE JEFATURA
   const excludedTemplateIds = [48, 58, 60, 62, 54, 50, 56, 52, 71, 72, 73];
  const excludedTitles = ["Reunión preoperacional","Reporte de Incidentes"];

  useEffect(() => {
    if (!rol || formsAD.length <= 0 || formsAM.length <= 0) return;

    const _rol = "- " + (rol || "");

    const _ad = formsAD.filter(
      ({ TemplateId, Titulo }) =>
        Titulo.includes(_rol) &&
        !excludedTemplateIds.includes(TemplateId) &&
        !excludedTitles.some(ex => Titulo.includes(ex))
    );

    const _am = formsAM.filter(
      ({ TemplateId, Titulo }) =>
        Titulo.includes(_rol) &&
        !excludedTemplateIds.includes(TemplateId) &&
        !excludedTitles.some(ex => Titulo.includes(ex))
    );

    const _p = formsP.filter(
      ({ TemplateId, Titulo }) =>
        Titulo.includes(_rol) &&
        !excludedTemplateIds.includes(TemplateId) &&
        !excludedTitles.some(ex => Titulo.includes(ex))
    );

    setFormsADByRol(_ad);
    setFormsAMByRol(_am);
    setFormsPByRol(_p);
  }, [formsAD, formsAM, formsP, rol]);

  useEffect(() => {
    if (searchValue) return;
    setFormsADByRolFiltered(formsADByRol);
    setFormsAMByRolFiltered(formsAMByRol);
    setFormsPByRolFiltered(formsPByRol);
  }, [searchValue, formsADByRol, formsAMByRol, formsPByRol]);

  useEffect(() => {
    const _search = prepareText(searchValue);
    const _formsADByRol = formsADByRol.filter(ad => {
      const _title = prepareText(ad.Titulo);
      return _title.includes(_search);
    });
    const _formsAMByRol = formsAMByRol.filter(ad => {
      const _title = prepareText(ad.Titulo);
      return _title.includes(_search);
    });
    const _formsPByRol = formsPByRol.filter(p => {
      const _title = prepareText(p.Titulo);
      return _title.includes(_search);
    });

    if (searchValue) {
      setActiveKey(["0", "1", "2"]);
      setAccordionProps({flush: false, alwaysOpen: true});
    } else {
      try {
        const saved = sessionStorage.getItem(STORAGE_KEY);
        setActiveKey(saved ? JSON.parse(saved) : ["0"]);
      } catch { setActiveKey(["0"]); }
      setAccordionProps({flush: true, alwaysOpen: false});
    }
    setFormsADByRolFiltered(_formsADByRol);
    setFormsAMByRolFiltered(_formsAMByRol);
    setFormsPByRolFiltered(_formsPByRol);
  }, [searchValue]);

  const handleActiveKey = key => {
    if (searchValue) return;
    const _key = String(key);
    setActiveKey(prev => {
      const next = _key === prev[0] ? [] : [_key];
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch {}
      return next;
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-5 mb-4">
          <input
            type="search"
            className="form-control form-control-lg"
            placeholder="Buscar..."
            value={searchValue}
            onChange={event => setSearchValue(event.target.value)}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <Accordion
            defaultActiveKey="0"
            activeKey={activeKey}
            {...accordionProps}
          >
            {hasCentro("Agua Dulce") && (
              <Accordion.Item eventKey="0" aria-busy>
                <Accordion.Header onClick={() => handleActiveKey(0)}>
                  <span className="text-primary-cermaq h5 mb-0">AGUA DULCE</span>
                </Accordion.Header>
                <Accordion.Body>
                  <ListGroup variant="flush">
                    {formsADByRolFiltered.map(form => (
                      <ListGroup.Item
                        key={form.TemplateId}
                        className="form-item"
                        onClick={() => navigate("forms/" + form.TemplateId)}
                      >
                        {handleCleanTitle(form.Titulo, rol)}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            )}
            {hasCentro("Agua Mar") && (
              <Accordion.Item eventKey="1">
                <Accordion.Header onClick={() => handleActiveKey(1)}>
                  <span className="text-primary-cermaq h5 mb-0">AGUAMAR</span>
                </Accordion.Header>
                <Accordion.Body>
                  <ListGroup variant="flush">
                    {formsAMByRolFiltered.map(form => (
                      <ListGroup.Item
                        key={form.TemplateId}
                        className="form-item"
                        onClick={() => navigate("forms/" + form.TemplateId)}
                      >
                        {handleCleanTitle(form.Titulo, rol)}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            )}
            {hasCentro("Procesos") && (
              <Accordion.Item eventKey="2">
                <Accordion.Header onClick={() => handleActiveKey(2)}>
                  <span className="text-primary-cermaq h5 mb-0">PROCESOS</span>
                </Accordion.Header>
                <Accordion.Body>
                  <ListGroup variant="flush">
                    {formsPByRolFiltered.map(form => (
                      <ListGroup.Item
                        key={form.TemplateId}
                        className="form-item"
                        onClick={() => navigate("forms/" + form.TemplateId)}
                      >
                        {handleCleanTitle(form.Titulo, rol)}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            )}
            {/* agregar nueva sección, se clona el coponente <Accordion.Item> con los formularios correspondientes y un nuevo eventKey */}
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default Inspections;
